'use client';

import { c as _c } from "react/compiler-runtime";
import { usePathname } from 'next/navigation';
import { useEffect } from 'react';
import { useCacheKey, useDeviceType, useOptimizely } from '../hooks';
import { resolveScripts } from './scripts.registry';
type ScriptsProps = {
  pageType: string;
};
export const Scripts = t0 => {
  const $ = _c(16);
  const {
    pageType
  } = t0;
  const {
    init
  } = useOptimizely();
  const {
    cookies,
    headers
  } = useCacheKey();
  const pathname = usePathname();
  const {
    deviceType
  } = useDeviceType();
  const scriptEntries = resolveScripts(pageType);
  let t1;
  if ($[0] !== cookies) {
    t1 = cookies.get("x-petm-team");
    $[0] = cookies;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const team = t1;
  let t2;
  if ($[2] !== headers) {
    t2 = headers.has("x-petm-bot");
    $[2] = headers;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isBot = t2;
  let t3;
  if ($[4] !== deviceType || $[5] !== init || $[6] !== isBot || $[7] !== pathname || $[8] !== team) {
    t3 = () => {
      if (pathname) {
        init({
          pathname,
          deviceType,
          team,
          isBot
        });
      }
    };
    $[4] = deviceType;
    $[5] = init;
    $[6] = isBot;
    $[7] = pathname;
    $[8] = team;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== deviceType || $[11] !== init || $[12] !== pathname) {
    t4 = [init, pathname, deviceType];
    $[10] = deviceType;
    $[11] = init;
    $[12] = pathname;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  useEffect(t3, t4);
  const t5 = scriptEntries.map(_temp);
  let t6;
  if ($[14] !== t5) {
    t6 = <>{t5}</>;
    $[14] = t5;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  return t6;
};
function _temp(t0) {
  const {
    id,
    Component
  } = t0;
  return <Component key={id} />;
}